export enum UserGroup {
  REGULAR = 'REGULAR',
  BETA = 'BETA',
  ADMIN = 'ADMIN',
}

export interface BetaUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  userGroup: UserGroup;
  dateJoined: string;
  fullName?: string;
}
